export type UpdateBrowserQueryArgs = {
    query: Record<string, string>,
    remove?: string[],
};

export default function UpdateBrowserQuery({ query, remove = [] }: UpdateBrowserQueryArgs): void {
    const theRouter = window.$router;

    const currentQuery: Record<string, unknown> = { ...(theRouter.currentRoute?.query ?? {}) };

    remove.forEach((key) => delete currentQuery[key]);

    const navigation = theRouter.replace({ query: { ...currentQuery, ...query } });

    if (navigation instanceof Promise) {
        navigation.catch(() => {});
    }
}
